"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirestoreInstance = getFirestoreInstance;
exports.getFirebaseFunctions = getFirebaseFunctions;
const app_1 = require("firebase/app");
const firebaseConfig = {
    apiKey: "AIzaSyAdZy_OGph3BeMs0CqwjYkV7NNQR40MjJQ",
    authDomain: "superkreatives-product-data.firebaseapp.com",
    projectId: "superkreatives-product-data",
    storageBucket: "superkreatives-product-data.firebasestorage.app",
    messagingSenderId: "942901361121",
    appId: "1:942901361121:web:f17909f805333fd79f7aa0",
};
let firestoreInstance = null;
let firebaseFunctions = null;
function getFirestoreInstance() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!firestoreInstance) {
            const { getFirestore } = yield Promise.resolve().then(() => __importStar(require("firebase/firestore")));
            const app = (0, app_1.initializeApp)(firebaseConfig);
            firestoreInstance = getFirestore(app);
        }
        return firestoreInstance;
    });
}
function getFirebaseFunctions() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!firebaseFunctions) {
            const { getFunctions } = yield Promise.resolve().then(() => __importStar(require("firebase/functions")));
            const app = (0, app_1.initializeApp)(firebaseConfig);
            firebaseFunctions = getFunctions(app);
        }
        return firebaseFunctions;
    });
}
